/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscPostMiscDateDiff } from "../../funcs/miscPostMiscDateDiff.js";
import { PostMiscDateDiffRequest$zodSchema } from "../../models/postmiscdatediffop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostMiscDateDiffRequest$zodSchema,
};

export const tool$miscPostMiscDateDiff: ToolDefinition<typeof args> = {
  name: "misc-post-misc-date-diff",
  description: `计算两个日期之间的时间差值

想知道两个日期之间相差多久？这个接口帮你精确计算时间差值。

## 功能概述
输入开始日期和结束日期，返回它们之间的时间差，包括总天数、总小时数、总分钟数、总秒数、总周数，以及人性化显示格式（如"1年2月3天"）。

## 日期格式
接口支持自动识别常见日期格式，包括：YYYY-MM-DD、YYYY/MM/DD、DD-MM-YYYY、ISO 8601（带时区）等。也可以通过\`format\`参数显式指定格式（如DD-MM-YYYY）。

> [!NOTE]
> 当结束日期早于开始日期时，返回的数值为负数。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscPostMiscDateDiff(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
